import React from 'react';

import { LoyaltyTiers } from 'src/components/widgets/loyalty-tiers/loyalty-tiers';
import { CashRedemption } from 'src/components/widgets/rewards/cash-redemption';
import { DiscountRedemption } from 'src/components/widgets/rewards/discount-redemption';
import { RedemptionType } from 'src/components/loyalty/rewards/dpos-utils';
import type { DutchiePosLoyaltyConfig, RewardsListV2 } from 'src/gql/graphql';

export type DutchieLoyaltyWidgetProps = {
  hasTiers: boolean;
  redemptionType: string;
  isWidgetLink?: boolean;
  locationMargin?: string;
  displayCTA?: boolean;
  activeEnterpriseId?: string;
  loyaltyEnterpriseConfigData?: DutchiePosLoyaltyConfig;
  rewardsEnterpriseData?: RewardsListV2;
};

/**
 * Renders the appropriate loyalty widget (tiers, discount redemption, or cash redemption)
 * based on program configuration. Use wherever the new loyalty widget is shown.
 */
export function DutchieLoyaltyWidget({
  hasTiers,
  redemptionType,
  isWidgetLink = true,
  locationMargin = '',
  displayCTA = false,
  activeEnterpriseId,
  loyaltyEnterpriseConfigData,
  rewardsEnterpriseData,
}: DutchieLoyaltyWidgetProps): JSX.Element | null {
  const normalizedRedemptionType = redemptionType?.toLowerCase() ?? '';

  if (hasTiers) {
    return (
      <LoyaltyTiers
        isWidgetLink={isWidgetLink}
        locationMargin={locationMargin}
        activeEnterpriseId={activeEnterpriseId}
        loyaltyEnterpriseConfigData={loyaltyEnterpriseConfigData}
        rewardsEnterpriseData={rewardsEnterpriseData}
      />
    );
  }

  if (normalizedRedemptionType === RedemptionType.discount) {
    return (
      <DiscountRedemption
        isWidgetLink={isWidgetLink}
        locationMargin={locationMargin}
        displayCTA={displayCTA}
        activeEnterpriseId={activeEnterpriseId}
        loyaltyEnterpriseConfigData={loyaltyEnterpriseConfigData}
        rewardsEnterpriseData={rewardsEnterpriseData}
      />
    );
  }

  if (normalizedRedemptionType === RedemptionType.cash) {
    return (
      <CashRedemption
        isWidgetLink={isWidgetLink}
        locationMargin={locationMargin}
        displayCTA={displayCTA}
        activeEnterpriseId={activeEnterpriseId}
        loyaltyEnterpriseConfigData={loyaltyEnterpriseConfigData}
        rewardsEnterpriseData={rewardsEnterpriseData}
      />
    );
  }

  return null;
}
